import { FcWithChildren } from "types/fcWithChildren";

export const LmList: FcWithChildren = ({ children }) => {
  return (
    <section className="lm__news link-listing with-animation">
      {children}
    </section>
  );
};
